import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ClientUser, ClientUserAddPayload, UserProjectRolesResponse, UserProjectRolesPayload } from '@zerops/models/client-user';

@Injectable({ providedIn: 'root' })
export class ClientUserBaseApi {
  #http = inject(HttpClient);

  createUser$(clientId: string, payload: Omit<ClientUserAddPayload, 'clientId'>) {
    return this.#http.post<ClientUser>(
      `/api/client/${clientId}/user`,
      payload
    );
  }

  getUserProjectRoles(userId: string) {
    return this.#http.get<UserProjectRolesResponse>(
      `/api/client-user/${userId}/roles`
    );
  }

  updateUserProjectRoles(
    userId: string,
    payload: UserProjectRolesPayload
  ) {
    return this.#http.put<UserProjectRolesResponse>(
      `/api/client-user/${userId}/roles`,
      payload
    );
  }
}
